<template>
  <div>
    <b-form-row>
      <b-col lg="2">
        <b-form-group
          label="Data Estimada Assinatura"
          label-size="sm"
          label-for="dt_assinatura_contrato_pa"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            placeholder="DD/MM/AAAA"
            v-model="wbs.dt_assinatura_contrato_pa"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group
          label="Data Assinatura Contrato"
          label-size="sm"
          label-for="dt_assinatura_contrato"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            placeholder="DD/MM/AAAA"
            v-model="wbs.dt_assinatura_contrato"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label="Data da OS" label-size="sm" label-for="dt_os">
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            placeholder="DD/MM/AAAA"
            v-model="wbs.dt_os"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group
          label="Data Inicio"
          label-size="sm"
          label-for="dt_ini_contrato"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            placeholder="DD/MM/AAAA"
            v-model="wbs.dt_ini_contrato"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="Nº Contrato"
          label-size="sm"
          label-for="nr_contrato"
        >
          <b-form-input
            autocomplete="off"
            size="sm"
            maxlength="50"
            id="nr_contrato"
            v-model="wbs.nr_contrato"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="3">
        <b-form-group label="Nº PRISM" label-size="sm" label-for="nr_prism">
          <b-form-input
            autocomplete="off"
            size="sm"
            maxlength="50"
            id="nr_prism"
            v-model="wbs.nr_prism"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="9">
        <b-form-group
          label="Nome da Empresa Contratada"
          label-size="sm"
          label-for="nome_empresa"
        >
          <b-form-input
            autocomplete="off"
            size="sm"
            maxlength="500"
            id="nome_empresa"
            v-model="wbs.nome_empresa"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="4">
        <b-form-group
          label="Valor Inicial do Contrato R$"
          label-size="sm"
          label-for="vl_inicial_contrato"
        >
          <b-form-input
            size="sm"
            maxlength="20"
            id="vl_inicial_contrato"
            v-model="wbs.vl_inicial_contrato"
            trim
            autocomplete="off"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="Valor Total com Reajustes R$"
          label-size="sm"
          label-for="vl_total_reajustes"
        >
          <b-form-input
            disabled
            size="sm"
            maxlength="20"
            id="vl_total_reajustes"
            v-model="wbs.vl_total_reajustes"
            trim
            autocomplete="off"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="Valor Total c/Reajustes 2ª Moeda"
          label-size="sm"
          label-for="vl_total_reajustes_m2"
        >
          <b-form-input
            disabled
            size="sm"
            maxlength="20"
            id="vl_total_reajustes_m2"
            v-model="wbs.vl_total_reajustes_m2"
            trim
            autocomplete="off"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="2">
        <b-form-group
          label="Prazo Inicial em Dias"
          label-size="sm"
          label-for="prazo_inicial_dias"
        >
          <b-form-input
            size="sm"
            maxlength="20"
            id="prazo_inicial_dias"
            v-model="wbs.prazo_inicial_dias"
            trim
            autocomplete="off"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 0,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '');
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group
          label="Prazo Planejado em Dias"
          label-size="sm"
          label-for="prazo_ajustado_dias"
        >
          <b-form-input
            size="sm"
            autocomplete="off"
            maxlength="20"
            id="prazo_ajustado_dias"
            v-model="wbs.prazo_ajustado_dias"
            trim
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 0,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '');
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group
          label="Prazo Reajustado em Dias"
          label-size="sm"
          label-for="prazo_reajustado_dias"
        >
          <b-form-input
            size="sm"
            autocomplete="off"
            maxlength="20"
            disabled
            class="text-right"
            id="prazo_reajustado_dias"
            v-model="wbs.prazo_reajustado_dias"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group
          label="Prazo em Meses"
          label-size="sm"
          label-for="prazo_meses"
        >
          <b-form-input
            disabled
            autocomplete="off"
            size="sm"
            maxlength="20"
            id="prazo_meses"
            v-model="getPrazoContratoMeses"
            trim
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 0,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label="Data Final" label-size="sm" label-for="data_final">
          <b-form-input
            disabled
            autocomplete="off"
            size="sm"
            maxlength="20"
            id="data_final"
            v-model="getDataFinalContrato"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-tabs
          content-class="v-tab-content"
          active-nav-item-class="v-tab-active"
          small
        >
          <b-tab title="Apostilas">
            <b-form-row>
              <b-col lg="6" class="mb-2">
                <b-button variant="success" size="sm" @click="showApostilas()">
                  <i class="fas fa-sync"></i> Atualizar Lista
                </b-button>
              </b-col>
              <b-col lg="6" class="text-right mb-2">
                <b-button variant="success" size="sm" @click="newApostila()">
                  <i class="fa fa-plus"></i> Adicionar
                </b-button>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <b-table
                  id="tblApostilas"
                  hover
                  bordered
                  resposive
                  small
                  striped
                  head-variant="dark"
                  primary-key="apostila_id"
                  selectable
                  select-mode="single"
                  selected-variant="primary"
                  show-empty
                  foot-clone
                  tbody-class="font08"
                  thead-class="font08"
                  tfoot-class="font08"
                  empty-text="Sem dados para exibir"
                  :items="apostilas.data"
                  :fields="apostilas.fields"
                  :busy="apostilas.busy"
                >
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      size="sm"
                      title="Alterar"
                      variant="success"
                      @click="editApostila(data.item)"
                    >
                      <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      title="Excluir"
                      variant="danger"
                      @click="deleteApostila(data.item)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </template>
                  <template v-slot:foot(nr_processo)
                    ><span>TOTAL</span></template
                  >
                  <template v-slot:foot(vl_apostila)
                    ><span>{{ getTotalApostilas }}</span></template
                  >
                  <template v-slot:foot(actions)>{{ "" }}</template>
                </b-table>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="Aditivos">
            <b-form-row>
              <b-col lg="6" class="mb-2">
                <b-button variant="success" size="sm" @click="showAditivos()">
                  <i class="fas fa-sync"></i> Atualizar Lista
                </b-button>
              </b-col>
              <b-col lg="6" class="text-right mb-2">
                <b-button variant="success" size="sm" @click="newAditivo()">
                  <i class="fa fa-plus"></i> Adicionar
                </b-button>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <b-table
                  id="tblAditivos"
                  hover
                  bordered
                  resposive
                  small
                  foot-clone
                  striped
                  head-variant="dark"
                  primary-key="aditivo_id"
                  selectable
                  select-mode="single"
                  selected-variant="primary"
                  show-empty
                  tbody-class="font08"
                  thead-class="font08"
                  tfoot-class="font08"
                  empty-text="Sem dados para exibir"
                  :items="aditivos.data"
                  :fields="aditivos.fields"
                  :busy="aditivos.busy"
                >
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(ind_tipo)="data">
                    <div class="text-center" v-if="data.item.ind_tipo === 1">
                      <b-badge variant="success">OFICIAL</b-badge>
                    </div>
                    <div class="text-center" v-else>
                      <b-badge variant="danger">NÃO OFICIAL</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      size="sm"
                      title="Alterar"
                      variant="success"
                      @click="editAditivo(data.item)"
                    >
                      <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      title="Excluir"
                      variant="danger"
                      @click="deleteAditivo(data.item)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </template>
                  <template v-slot:foot(ind_tipo)><span>TOTAL</span></template>
                  <template v-slot:foot(vl_estimado)
                    ><span>{{ getTotalEstimadoAditivos }}</span></template
                  >
                  <template v-slot:foot(vl_real)
                    ><span>{{ getTotalRealAditivos }}</span></template
                  >
                  <template v-slot:foot(perc_aditivo)
                    ><span>{{ getTotalPercAditivos }}</span></template
                  >
                  <template v-slot:foot(prazo_dias)>{{
                    getTotalPrazoDiasAditivos
                  }}</template>
                  <template v-slot:foot(actions)>{{ "" }}</template>
                  <template v-slot:foot(nr_processo)>{{ "" }}</template>
                </b-table>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="Anexos do Contrato">
            <AnexosContrato :wbs="wbs" :acao="acao" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-form-row>
    <ModalApostila
      :apostila="curApostila"
      :acao="curAcao"
      :wbs="wbs"
      @updatedApostila="
        showApostilas();
        refreshWBS();
      "
    />
    <ModalAditivo
      :aditivo="curAditivo"
      :acao="curAcao"
      :wbs="wbs"
      @updatedAditivo="
        showAditivos();
        refreshWBS();
      "
    />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import ModalApostila from "./ModalApostila";
import ModalAditivo from "./ModalAditivo";

import moment from "moment";
import axios from "axios";
import { baseApiUrl, showError, formatMoney } from "@/global";

import { bidbus } from "@/main";
import AnexosContrato from "./AnexosContrato.vue";

export default {
  name: "TabContrato",
  components: { DatePicker, ModalApostila, ModalAditivo, AnexosContrato },
  computed: {
    getTotalApostilas: function() {
      let valor = this.apostilas.data.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_apostila);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalRealAditivos: function() {
      let valor = this.aditivos.data.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_real);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalEstimadoAditivos: function() {
      let valor = this.aditivos.data.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_estimado);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPrazoDiasAditivos: function() {
      let valor = this.aditivos.data.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.prazo_dias);
      }, 0.0);
      return formatMoney(valor, 0, "", ".", ",");
    },
    getTotalPercAditivos: function() {
      let valor = this.aditivos.data.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.perc_aditivo);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",") + "%";
    },

    getPrazoContratoMeses: function() {
      let valor = parseInt(this.wbs.prazo_reajustado_dias);
      return Math.ceil(valor / 30);
    },

    getDataFinalContrato: function() {
      if ((this.wbs.dt_ini_contrato || "") == "") return "";
      let _dtini = moment(this.wbs.dt_ini_contrato, "YYYY-MM-DD");
      return _dtini
        .add(this.wbs.prazo_reajustado_dias, "days")
        .format("DD/MM/YYYY");
    },
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  data: function() {
    return {
      curApostila: {},
      curAditivo: {},
      curAcao: "view",
      apostilas: {
        data: [],
        fields: [
          { key: "nr_processo", label: "Nº Processo" },
          {
            key: "vl_apostila",
            label: "Valor de Apostila R$",
            class: "w160-field text-right",
            formatter: function(val) {
              return formatMoney(val, 2, "", ".", ",");
            },
          },
          { key: "actions", class: "w100-field", label: "Ações" },
        ],
        busy: false,
      },
      aditivos: {
        data: [],
        fields: [
          { key: "ind_tipo", label: "Tipo" },
          { key: "nr_processo", label: "Nº Processo" },
          {
            key: "vl_estimado",
            class: "text-right",
            label: "Valor Estimado R$",
            formatter: function(val) {
              return formatMoney(val, 2, "", ".", ",");
            },
          },
          {
            key: "vl_real",
            class: "text-right",
            label: "Valor Oficial R$",
            formatter: function(val) {
              return formatMoney(val, 2, "", ".", ",");
            },
          },
          {
            key: "perc_aditivo",
            class: "text-right",
            label: "% Aditivo",
            formatter: function(val) {
              return formatMoney(val, 2, "", ".", ",");
            },
          },
          { key: "prazo_dias", class: "text-right", label: "Prazo em dias" },
          { key: "actions", label: "Ações" },
        ],
        busy: false,
      },
    };
  },
  methods: {
    newApostila() {
      this.curApostila = {};
      this.curAcao = "new";
      this.$bvModal.show("modal-apostila");
    },
    showApostilas() {
      axios
        .get(`${baseApiUrl}/bid/apostilas/listar`, {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
          },
        })
        .then((resp) => {
          this.apostilas.data = resp.data;
        })
        .catch((ex) => {
          showError(ex);
        });
    },
    editApostila(item) {
      this.curApostila = { ...item };
      this.curAcao = "edit";
      this.$bvModal.show("modal-apostila");
    },
    deleteApostila(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir a Apostila [${item.nr_processo}]?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(`${baseApiUrl}/bid/apostilas/${item.apostila_id}`)
              .then(() => {
                this.showApostilas();
                this.refreshWBS();
                bidbus.$emit("refreshMedicoes", "deleteApostila");
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    newAditivo() {
      this.curAditivo = {
        vl_estimado: 0,
        vl_real: 0,
        perc_aditivo: 0,
        prazo_dias: 0,
        ind_tipo: 1,
        nr_processo: "",
      };
      this.curAcao = "new";
      this.$bvModal.show("modal-aditivo");
    },
    showAditivos() {
      axios
        .get(`${baseApiUrl}/bid/aditivos/listar`, {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
          },
        })
        .then((resp) => {
          this.aditivos.data = resp.data;
        })
        .catch((ex) => {
          showError(ex);
        });
    },
    refreshWBS() {
      if (this.wbs && this.wbs.programa_id) {
        axios
          .get(
            `${baseApiUrl}/bid/programawbs/${btoa(this.wbs.programa_id)}/${
              this.wbs.wbs_id
            }`
          )
          .then((resp) => {
            this.wbs.vl_total_reajustes = resp.data.vl_total_reajustes;
            this.wbs.vl_total_reajustes_m2 = resp.data.vl_total_reajustes_m2;
            this.wbs.prazo_reajustado_dias = resp.data.prazo_reajustado_dias;
          })
          .catch((err) => {
            showError(err);
          });
      }
    },
    editAditivo(item) {
      this.curAditivo = { ...item };
      this.curAcao = "edit";
      this.$bvModal.show("modal-aditivo");
    },
    deleteAditivo(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Aditivo [${item.nr_processo}]?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(`${baseApiUrl}/bid/aditivos/${item.aditivo_id}`)
              .then(() => {
                this.showAditivos();
                bidbus.$emit("refreshMedicoes", "deleleteAditivo");
                this.refreshWBS();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
  },
  watch: {
    wbs: {
      immediate: true,
      handler() {
        this.showApostilas();
        this.showAditivos();
      },
    },
  },
  created() {
    bidbus.$on("updatedWBS", () => {
      this.refreshWBS();
    });
  },
  mounted() {},
};
</script>
<style></style>
